import {
  useMutation,
  useQueryClient,
  type UseMutateAsyncFunction,
  type UseMutateFunction,
} from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { removePhoneBill } from '@services/cpqService';
import type { PhoneNumberOptionsResponse } from '@t/checkout.types';

export interface UseRemovePhoneBillResult {
  remove: UseMutateFunction<PhoneNumberOptionsResponse, Error, string>;
  removeAsync: UseMutateAsyncFunction<PhoneNumberOptionsResponse, Error, string>;
  isRemoving: boolean;
}

export const useRemovePhoneBill = (sessionId: string | null): UseRemovePhoneBillResult => {
  const queryClient = useQueryClient();

  const mutation = useMutation<PhoneNumberOptionsResponse, Error, string>({
    mutationFn: (fileId) => removePhoneBill(sessionId!, fileId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['existingPhoneOptions', sessionId] });
    },
    onError: () => {
      toast.error('Failed to remove the bill file. Please try again.');
    },
  });

  return {
    remove: mutation.mutate,
    removeAsync: mutation.mutateAsync,
    isRemoving: mutation.isPending,
  };
};
